module.exports = "./img/b767fc22703ed4a7faabf678f334bb2f.jpg";